import { SelectionToolbar } from '@qse/ui'
import { type FileItem } from '@qse/utils'
import React from 'react'

interface FileExplorerToolbarProps {
  showSelectionToolbar?: boolean
  selectedFiles: Set<string | number>
  allFiles: FileItem[]
  trashMode?: boolean
  currentFolderPath?: string
  currentFolderId?: string
  parentId?: string
  onCopy: (fileIds: string[]) => Promise<void>
  onDelete: (fileIds: string[], onSuccess?: () => void) => Promise<void>
  onDownload: (fileIds: string[]) => Promise<void>
  onRename: (fileIds: string[]) => Promise<void>
  onRestore: (fileIds: string[]) => Promise<void>
  onDeleteForever: (fileIds: string[]) => Promise<void>
  onDeleteGhostFiles?: (fileIds: string[]) => Promise<void>
  onReset: () => void
  onToggleFavorite?: (fileIds: string[]) => Promise<void>
}

const FileExplorerToolbar: React.FC<FileExplorerToolbarProps> = ({
  showSelectionToolbar = true,
  selectedFiles,
  allFiles,
  trashMode = false,
  currentFolderPath,
  currentFolderId,
  parentId,
  onCopy,
  onDelete,
  onDownload,
  onRename,
  onRestore,
  onDeleteGhostFiles,
  onReset,
  onToggleFavorite,
}) => {
  // Check if any selected files are not AVAILABLE
  const hasUnavailableFiles = Array.from(selectedFiles).some(fileId => {
    const file = allFiles.find(f => f.id === fileId)

    return file && file.status !== 'AVAILABLE'
  })

  // Only show SelectionToolbar if showSelectionToolbar is true, there are selected files, and all selected files are AVAILABLE
  const shouldShowSelectionToolbar = showSelectionToolbar && selectedFiles.size > 0

  if (!shouldShowSelectionToolbar) {
    // Placeholder with same height/margin as toolbar+tip
    return (
      <div className="h-[40px] text-gray-900 dark:!text-white w-full min-h-11 flex items-center justify-start gap-2 sm:gap-3 px-2 sm:px-3 py-2 rounded-lg flex-wrap" />
    )
  }

  return (
    <SelectionToolbar
      allFiles={allFiles}
      currentFolderId={currentFolderId}
      currentFolderPath={currentFolderPath}
      hasUnavailableFiles={hasUnavailableFiles}
      parentId={parentId}
      selectedCount={selectedFiles.size}
      selectedFiles={selectedFiles}
      trashMode={trashMode}
      onCopy={onCopy}
      onDelete={onDelete}
      onDeleteGhostFiles={onDeleteGhostFiles}
      onDownload={onDownload}
      onRename={onRename}
      onReset={onReset}
      onRestore={onRestore}
      onToggleFavorite={onToggleFavorite}
    />
  )
}

export default FileExplorerToolbar
